import React from "react";

const Loader = () => {
  return (
    <div class="loader-container">
      <span class="loader-inner"></span>
    </div>
  );
};

export default Loader;
